import React from 'react';
import { StyledTextField } from './InputStyles';

/**
 * TextInput - унифицированный компонент для текстового ввода
 *
 * @param {string} label - Текст label (опционально)
 * @param {string} value - Значение поля
 * @param {function} onChange - Callback при изменении (получает event)
 * @param {string} placeholder - Placeholder текст
 * @param {boolean} disabled - Заблокировано ли поле
 * @param {boolean} fullWidth - На всю ширину (по умолчанию true)
 * @param {string} type - Тип input (text, email, tel, number)
 * @param {object} sx - Дополнительные стили
 */
export default function TextInput({
    label,
    value,
    onChange,
    placeholder,
    disabled = false,
    fullWidth = true,
    type = 'text',
    sx,
    ...rest
}) {
    return (
        <StyledTextField
            variant="outlined"
            label={label}
            value={value ?? ''}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            fullWidth={fullWidth}
            type={type}
            sx={sx}
            autoComplete="off"
            {...rest}
        />
    );
}
